import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
// 现有在线咨询浮窗暂时隐藏，改用第三方（爱番番）客服代码，后期再对接
// import FloatingContact from "./components/feature/FloatingContact";
import { useEffect, useRef } from "react";
import { recordPageView } from "./api/pageViewApi";

// 每次路由切换时回到顶部；如果 URL 带 hash 则滚动到对应锚点
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPathname = useRef(pathname);
  const prevHash = useRef(hash);

  useEffect(() => {
    const pathChanged = prevPathname.current !== pathname;
    const hashChanged = prevHash.current !== hash;

    if (pathChanged || hashChanged) {
      if (hash) {
        // 等待页面渲染完成后再定位到锚点
        const scrollToHash = () => {
          const el = document.getElementById(hash.slice(1));
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        };
        // 跨页面跳转需要更长的等待时间让目标页渲染
        setTimeout(scrollToHash, pathChanged ? 300 : 50);
      } else if (pathChanged) {
        window.scrollTo({ top: 0, behavior: "instant" });
      }
      prevPathname.current = pathname;
      prevHash.current = hash;
    }

    // Record page view on every route change
    if (pathChanged) {
      recordPageView(pathname);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <Navbar />
        <AppRoutes />
        <Footer />
        {/* <FloatingContact /> 暂时隐藏，改用爱番番第三方客服 */}
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
